import { render, staticRenderFns } from "./NiceContent.vue?vue&type=template&id=6f06a5ed&lang=pug&"
import script from "./NiceContent.vue?vue&type=script&lang=ts&"
export * from "./NiceContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports